export const APIS = {
    LOG_IN: "/api/auth/login",
    CHANGE_PASSWORD: "/api/auth/change-password",
    REFRESH_TOKEN: "/api/auth/refresh-access-token",
    USER_PROFILE: "/api/profile/getProfile",
    EMPLOYEE_LIST: "/api/user/all",
    /** Primary; employeeApi falls back to /api/user/directory if 404. */
    EMPLOYEE_DIRECTORY: "/api/profile/directory",
    EMPLOYEE_DIRECTORY_FALLBACK: "/api/user/directory",
    GET_ALL_ROLES: "/api/admin/role/all",
    CREATE_USER: "/api/user/create",
    UPLOAD_FILE: '/api/upload',
    UPDATE_USER: "/api/user/:userId/update",
    DELETE_USER: "/api/user/:userId/delete",
    UPDATE_ATTENDANCE_CODE: "/api/user/:userId/attendance-code",
    UPDATE_EMPLOYEE_CODE: "/api/user/:userId/employee-code",
    GET_ALL_PROJECT: "/api/project/all",
    CREATE_PROJECT: "api/project/create",
    UPDATE_PROJECT: "/api/project/:projectId/update",
    GET_USER_LEAVES: "/api/leave-request/forUser",
    CREATE_LEAVE_REQUEST: "/api/leave-request/create",
    /** HR/Admin: create approved WFH for an employee. */
    CREATE_WFH_FOR_EMPLOYEE: "/api/leave-request/create-wfh-for-employee",
    CANCEL_PENDING_LEAVE_REQUEST: "/api/leave-request/cancel-pending",
    /** Same handler as cancel-pending (backend alias). */
    CANCEL_PENDING_LEAVE_REQUEST_ALT: "/api/leave-request/cancelPending",
    UPDATE_OWN_LEAVE_REQUEST: "/api/leave-request/update-own",
    /** Same handler as update-own (backend alias). */
    UPDATE_OWN_LEAVE_REQUEST_ALT: "/api/leave-request/updateOwn",
    GET_ALL_ROLES: "/api/admin/role/all",
    GET_ALL_ROLE_MODULES: "/api/admin/role/modules",
    CREATE_ROLE: "/api/admin/role/create",
    EDIT_ROLE: "/api/admin/role/:roleId/update",
    DELETE_ROLE: "/api/admin/role/:roleId/delete",
    /** Approver list; add `?attention=1` to count/filter pending approvals + approved leaves awaiting cancel review. */
    GET_ALL_LEAVES: "/api/leave-request/forApprover",
    /** Approved leaves overlapping a date — any authenticated user (dashboard widget). */
    LEAVE_TEAM_ON_LEAVE: "/api/leave-request/team-on-leave",
    ADD_LEAVE_COMMENT: "/api/leave-request/update/admin/status",
    /** Admin (non-HR): internal note on pending leave — emailed to HR, visible to HR only. */
    ADD_ADMIN_HR_LEAVE_NOTE: "/api/leave-request/admin-hr-note",
    /** Employee: submit request to cancel approved leave (HR/Admin reviews). */
    CANCEL_APPROVED_LEAVE: "/api/leave-request/cancel-approved",
    /** HR/Admin: approve or reject a pending cancellation of approved leave. */
    REVIEW_CANCEL_APPROVED_LEAVE: "/api/leave-request/review-cancel-approved",
    /** HR/Admin: cancel any approved leave (sets status to cancelled). */
    REVOKE_APPROVED_LEAVE: "/api/leave-request/revoke-approved",
    SEND_EMAIL_FOR_LEAVE_REQUEST: "/api/leave-request/update/status",
    GET_LEAVE_NOTIFICATION_CONFIG: "/api/leave-request/notification-config",
    UPDATE_LEAVE_NOTIFICATION_CONFIG: "/api/leave-request/notification-config",
    SEND_LEAVE_NOTIFICATION_TEST: "/api/leave-request/notification-config/test",
    LEAVE_BALANCE_ME: "/api/leave-request/leave-balance/me",
    LEAVE_REQUEST_PREVIEW: "/api/leave-request/leave-balance/preview",
    LEAVE_BALANCE_ADMIN: "/api/leave-request/leave-balance/admin",
    LEAVE_BALANCE_ADMIN_EX_EMPLOYEES: "/api/leave-request/leave-balance/admin/ex-employees",
    UPDATE_USER_PROFILE: "/api/profile/info",
    ATTENDANCE_CALENDAR: "/api/attendance/calendar",
    ATTENDANCE_LOGS: "/api/attendance/logs",
    ATTENDANCE_SYNC: "/api/attendance/sync",
    ATTENDANCE_CONFIG: "/api/attendance/config",
    ATTENDANCE_WEBHOOK_STATUS: "/api/attendance/webhook-status",
    ATTENDANCE_MACHINE_USERS: "/api/attendance/machine-users",
    ATTENDANCE_SYNC_DASHBOARD_USER_TO_MACHINE: "/api/attendance/machine-users/sync-dashboard-user/:userId",
    ATTENDANCE_ANALYTICS_DAILY: "/api/attendance/analytics/daily",
    ATTENDANCE_ANALYTICS_TEAM_WEEK: "/api/attendance/analytics/team-week",
    ATTENDANCE_DAY_OVERRIDE: "/api/attendance/analytics/day-override",
    ATTENDANCE_HOLIDAYS: "/api/attendance/holidays",
    /** Current team praise shown on dashboard (GET all users; PUT requires PRAISE_MESSAGES create). */
    PRAISE_CURRENT: "/api/praise/current",
    PROJECT_DOCUMENTS_MINE: "/api/project-documentation/mine",
    PROJECT_DOCUMENTS_CREATE: "/api/project-documentation/create",
    PROJECT_DOCUMENTS_PROJECTS: "/api/project-documentation/projects",
    PROJECT_DOCUMENTS_EMPLOYEES: "/api/project-documentation/employees",
    PROJECT_DOCUMENTS_BY_EMPLOYEE: "/api/project-documentation/by-employee",
    PROJECT_DOCUMENT_BY_ID: "/api/project-documentation/:documentId",
    PROJECT_DOCUMENTS_CREATE_WITH_FILE: "/api/project-documentation/create-with-file",
    PROJECT_DOCUMENT_FILE: "/api/project-documentation/:documentId/file",
    PROJECT_DOCUMENTATION_UPDATE: "/api/project-documentation/:documentId",
    PROJECT_DOCUMENTATION_UPDATE_FILE: "/api/project-documentation/:documentId/file",
    PROJECT_DOCUMENTATION_SWAP_FILES: "/api/project-documentation/:documentId/files/swap",
    PROJECT_DOCUMENTATION_REORDER_FILES: "/api/project-documentation/:documentId/files/reorder",
    PROJECT_DOCUMENTATION_EDIT_REQUEST: "/api/project-documentation/:documentId/edit-request",
    PROJECT_DOCUMENTATION_EDIT_REQUESTS_PENDING: "/api/project-documentation/edit-requests/pending",
    PROJECT_DOCUMENTATION_EDIT_REQUEST_REVIEW: "/api/project-documentation/edit-requests/:requestId/review",
    PROJECT_DOCUMENTATION_PUBLIC: "/api/project-documentation/:documentId/public",
    PROJECT_DOCUMENTATION_SHARES: "/api/project-documentation/:documentId/shares",
    /** Company policy PDF — metadata JSON is encrypted; `/view` is raw PDF (use axios + arraybuffer). */
    COMPANY_POLICY: "/api/company-policy",
    /** HR/Admin: user ids that already received work-anniversary email today. */
    WORK_ANNIVERSARY_SENT_TODAY: "/api/work-anniversary/sent-today",
    /** HR/Admin: send work-anniversary congratulations email to an employee (today only, once). */
    WORK_ANNIVERSARY_SEND_EMAIL: "/api/work-anniversary/:userId/send-email",
    /** HR/Admin: user ids that already received birthday email today. */
    BIRTHDAY_SENT_TODAY: "/api/birthday/sent-today",
    /** HR/Admin: send birthday congratulations email to an employee (today only, once). */
    BIRTHDAY_SEND_EMAIL: "/api/birthday/:userId/send-email",
    /** Admin: Google Sheet URL for an employee's daily task spreadsheet. */
    TASK_EMPLOYEE_SPREADSHEET: "/api/task/spreadsheet",
    /** Export employee Google Sheet month tab as PDF for invoice email. */
    TASK_EMPLOYEE_TIMESHEET_PDF: "/api/task/spreadsheet/:userId/timesheet-pdf",
    /** Daily Work Updates: send table-formatted update email via SMTP. */
    DAILY_HOURS_SEND_VIEW_EMAIL: "/api/task/send-view-email",
    TASK_BOARD_CARDS: "/api/task/board-cards",
    TASK_MONTHLY_ACCESS_STATUS: "/api/task/access-status",
    TASK_MONTHLY_ACCESS_REQUEST: "/api/task/access-request",
    TASK_MONTHLY_ACCESS_PENDING_REQUESTS: "/api/task/access-requests/pending",
    TASK_MONTHLY_ACCESS_HISTORY: "/api/task/access-requests/history",
    TASK_MONTHLY_ACCESS_HISTORY_REVIEW: "/api/task/access-requests/history/review",
    TASK_MONTHLY_ACCESS_REVIEW: "/api/task/access-requests/:requestId/review",
    /** Invoice Management: send invoice email with PDF attachment. */
    INVOICE_SEND_EMAIL: "/api/invoice/send-email",
    INVOICE_MANAGEMENT: "/api/invoice",
    INVOICE_MANAGEMENT_BY_ID: "/api/invoice/:invoiceId",
    COMPANY_DETAILS: "/api/company-details",
    COMPANY_DETAILS_BY_ID: "/api/company-details/:companyId",
    CLIENT_MANAGEMENT: "/api/client-management",
    CLIENT_MANAGEMENT_BY_ID: "/api/client-management/:clientId",
    FINANCE_DASHBOARD: "/api/finance/dashboard",
    FINANCE_SALARY_STRUCTURES: "/api/finance/salary-structures",
    FINANCE_SALARY_STRUCTURE_DELETE: "/api/finance/salary-structures/:structureId",
    FINANCE_SALARY_SHEETS: "/api/finance/salary-sheets",
    FINANCE_SALARY_SHEET_BY_MONTH: "/api/finance/salary-sheets/by-month",
    FINANCE_SALARY_SHEET: "/api/finance/salary-sheets/:sheetId",
    FINANCE_SALARY_SHEET_GENERATE: "/api/finance/salary-sheets/generate",
    FINANCE_SALARY_SHEET_MANUAL: "/api/finance/salary-sheets/manual",
    FINANCE_SALARY_SHEET_DELETE: "/api/finance/salary-sheets/:sheetId",
    FINANCE_SALARY_SHEET_ENTRIES_BY_COMPANY: "/api/finance/salary-sheets/:sheetId/entries/by-company",
    FINANCE_EMPLOYEES_FOR_SHEET_IMPORT: "/api/finance/employees-for-sheet-import",
    FINANCE_SALARY_SHEET_ENTRIES: "/api/finance/salary-sheets/:sheetId/entries",
    FINANCE_SALARY_SHEET_ENTRIES_BULK: "/api/finance/salary-sheets/:sheetId/entries/bulk",
    FINANCE_SALARY_ENTRY_UPDATE: "/api/finance/salary-sheet-entries/:entryId",
    FINANCE_SALARY_ENTRY_DELETE: "/api/finance/salary-sheet-entries/:entryId",
    FINANCE_CALCULATE: "/api/finance/calculate",
    FINANCE_SALARY_COMPANIES: "/api/finance/salary-companies",
    FINANCE_SALARY_COMPANY: "/api/finance/salary-companies/:companyId",
    FINANCE_DOCUMENTS: "/api/finance/documents",
    FINANCE_DOCUMENT: "/api/finance/documents/:documentId",
    FINANCE_DOCUMENT_VIEW: "/api/finance/documents/:documentId/view",
    FINANCE_DOCUMENT_INVOICE_VIEW: "/api/finance/documents/:documentId/invoice",
    FINANCE_DOCUMENT_UPI_SCREENSHOT_VIEW: "/api/finance/documents/:documentId/upi-screenshot",
    FINANCE_DOCUMENT_DELETE: "/api/finance/documents/:documentId",
    FINANCE_EXPENSES: "/api/finance/expenses",
    FINANCE_EXPENSE: "/api/finance/expenses/:expenseId",
    FINANCE_EXPENSE_INVOICE_VIEW: "/api/finance/expenses/:expenseId/invoice/view",
    FINANCE_EXPENSE_UPI_SCREENSHOT_VIEW: "/api/finance/expenses/:expenseId/upi-screenshot/view",
    SALARY_SLIPS: "/api/salary-slips",
    SALARY_SLIP: "/api/salary-slips/:slipId",
    SALARY_SLIP_SEND_EMAIL: "/api/salary-slips/send-email",
    COMPANY_OPS_PUBLIC_HOLIDAYS: "/api/company-ops/public-holidays",
    COMPANY_OPS_PUBLIC_HOLIDAYS_IMPORT_PDF: "/api/company-ops/public-holidays/import-pdf",
    PROJECT_BOARD_ALL: "/api/project-board/all",
    PROJECT_BOARD_CREATE: "/api/project-board/create",
    PROJECT_BOARD_BY_ID: "/api/project-board/:boardId",
    PROJECT_BOARD_UPDATE: "/api/project-board/:boardId",
    PROJECT_BOARD_DELETE: "/api/project-board/:boardId",
    PROJECT_BOARD_LISTS: "/api/project-board/:boardId/lists",
    PROJECT_BOARD_LISTS_MOVE: "/api/project-board/:boardId/lists/move",
    PROJECT_BOARD_LIST_UPDATE: "/api/project-board/lists/:listId",
    PROJECT_BOARD_CARDS: "/api/project-board/lists/:listId/cards",
    PROJECT_BOARD_CARD: "/api/project-board/cards/:cardId",
    PROJECT_BOARD_CARD_DELETE: "/api/project-board/cards/:cardId",
    PROJECT_BOARD_CARD_MOVE: "/api/project-board/cards/:cardId/move",
    PROJECT_BOARD_CARD_COMMENTS: "/api/project-board/cards/:cardId/comments",
    PROJECT_BOARD_CARD_ATTACHMENTS: "/api/project-board/cards/:cardId/attachments",
    PROJECT_BOARD_CARD_ATTACHMENT_VIEW:
        "/api/project-board/cards/:cardId/attachments/:attachmentId/view",
    PROJECT_BOARD_SEARCH: "/api/project-board/search",
    SOPS: "/api/sops",
    SOP_BY_ID: "/api/sops/:sopId",
    SOP_VIEW: "/api/sops/:sopId/view",
    SOP_ASSIGNMENTS: "/api/sops/:sopId/assignments",
    OFFBOARDING_DOCUMENTS: "/api/offboarding-documents",
    OFFBOARDING_DOCUMENT_BY_ID: "/api/offboarding-documents/:documentId",
    OFFBOARDING_DOCUMENT_VIEW: "/api/offboarding-documents/:documentId/view",
    OFFBOARDING_DOCUMENT_ASSIGNMENTS: "/api/offboarding-documents/:documentId/assignments",
    OFFBOARDING_DOCUMENT_SUBMIT: "/api/offboarding-documents/assignments/:assignmentId/submit",
    OFFBOARDING_DOCUMENT_SUBMISSION_VIEW:
        "/api/offboarding-documents/assignments/:assignmentId/submission/view",
    PROJECT_CREDENTIALS_PERSONAL: "/api/project-credentials/personal",
    PROJECT_CREDENTIALS_PERSONAL_BY_ID: "/api/project-credentials/personal/:id",
    PROJECT_CREDENTIALS_PERSONAL_SHARES: "/api/project-credentials/personal/:id/shares",
    PROJECT_CREDENTIALS_LIST: "/api/project-credentials/project/:projectId/credentials",
    PROJECT_CREDENTIALS_BY_ID: "/api/project-credentials/project/:projectId/credentials/:id",
    PROJECT_CREDENTIALS_SHARES: "/api/project-credentials/project/:projectId/credentials/:id/shares",
    PROJECT_INSTRUCTIONS_LIST: "/api/project-credentials/project/:projectId/instructions",
    PROJECT_INSTRUCTIONS_BY_ID: "/api/project-credentials/project/:projectId/instructions/:id",
    PROJECT_RESOURCES_LIST: "/api/project-credentials/project/:projectId/resources",
    PROJECT_RESOURCES_BY_ID: "/api/project-credentials/project/:projectId/resources/:id",
    PROJECT_CREDENTIAL_FILES_SHARED: "/api/project-credentials/files",
    PROJECT_CREDENTIAL_FILE_SHARED_BY_ID: "/api/project-credentials/files/:id",
    PROJECT_CREDENTIAL_FILE_SHARED_DOWNLOAD: "/api/project-credentials/files/:id/download",
    PROJECT_CREDENTIAL_FILE_SHARED_SHARES: "/api/project-credentials/files/:id/shares",
    PROJECT_CREDENTIAL_FILES_ALL: "/api/project-credentials/project-files",
    PROJECT_CREDENTIAL_FILES_SHARED_WITH_ME: "/api/project-credentials/project-files/shared-with-me",
    PROJECT_CREDENTIAL_FILES_LIST: "/api/project-credentials/project/:projectId/files",
    PROJECT_CREDENTIAL_FILE_BY_ID: "/api/project-credentials/project/:projectId/files/:id",
    PROJECT_CREDENTIAL_FILE_DOWNLOAD: "/api/project-credentials/project/:projectId/files/:id/download",
    PERFORMANCE_CRITERIA_LATE_ARRIVALS: "/api/performance-criteria/late-arrivals",
    PERFORMANCE_CRITERIA_SEND_EMAIL: "/api/performance-criteria/late-arrivals/send-email",
    TIME_TRACKER_ACTIVE: "/api/time-tracker/active",
    TIME_TRACKER_CHECK_IN: "/api/time-tracker/check-in",
    TIME_TRACKER_CHECK_OUT: "/api/time-tracker/check-out",
    TIME_TRACKER_ACTIVITY: "/api/time-tracker/activity",
    TIME_TRACKER_VISIBILITY: "/api/time-tracker/visibility",
    TIME_TRACKER_IDLE_START: "/api/time-tracker/idle-start",
    TIME_TRACKER_IDLE_ACK: "/api/time-tracker/idle-ack",
    TIME_TRACKER_PAUSE: "/api/time-tracker/pause",
    TIME_TRACKER_RESUME: "/api/time-tracker/resume",
    TIME_TRACKER_HISTORY: "/api/time-tracker/history",
    TIME_TRACKER_ADMIN_STATUS: "/api/time-tracker/admin/status",
    TIME_TRACKER_ADMIN_HISTORY: "/api/time-tracker/admin/history",
};

/** Window event: sidebar refetches leave-approver pending badge after approver actions. */
export const LEAVE_APPROVE_PENDING_REFRESH_EVENT = "leave-approve-pending-refresh";
/** Window event: time tracker pages refresh session/history after idle auto-pause etc. */
export const TIME_TRACKER_SESSION_UPDATED_EVENT = "time-tracker-session-updated";
/** Window event: sidebar refetches daily-work access-request pending badge. */
export const DAILY_HOURS_ACCESS_PENDING_REFRESH_EVENT = "daily-hours-access-pending-refresh";